<div tabindex="0" class="me-sr-living-conditions" *ngIf="data">
    <div class="me-sr-living-conditions--header">
        {{data.headline}}
    </div>
    <div class="me-sr-living-conditions--body">
        <div tabindex="0" class="me-sr-living-conditions--body--node" [class.active]="ids.indexOf(livingCondition.id) >= 0" *ngFor="let livingCondition of livingConditions" 
            (click)="selectNode(livingCondition.id)"
            (keyup.enter)="selectNode(livingCondition.id)">
            {{livingCondition.name}}
        </div>
    </div>
    <div tabindex="0" class="me-sr-living-conditions--note">
        {{data.infoText}}
    </div>
    <div class="me-sr-living-conditions--button">
        <button class="btn btn--primary" (click)="next()">
            {{ 'Continue' | translate}}
        </button>
    </div>
</div>